<template>
  <page-header-wrapper>
    <div class="home">
    
      <div class="home_c">
        {{ currentTime }}
      </div>
    </div>
  </page-header-wrapper>
</template>

<script>
import { mapGetters } from 'vuex'
import { PageHeaderWrapper } from '@/components/ProLayout'
import { statHome } from '@/api/system/user'
import { noticeWay } from '@/api/system/notice'
import BarChart from './Charts/barChart.vue'
import mapChart from './Charts/map.vue'
import Pie from './Charts/pie.vue'

export default {
  name: 'Index',
  components: {
    PageHeaderWrapper,
    BarChart,
    Pie,
    mapChart,
  },
  data() {
    return {
      chartData: {},
      roleGroup: {},
      postGroup: {},
      currentTime: '',
      statistics01: {},
      show: false,
      chartData1: {},
    }
  },
  computed: {
    ...mapGetters(['avatar', 'nickname', 'index']),
    stortIndex() {
      console.log(this.$route, '测试数据====')
      const path = this.$route.path
      if (path === '/index') {
        this.getUser()
      }
      return this.$route.path
    },
  },
  // watch: {
  //   index()
  // },
  created() {
    console.log('测试梳理===')
    // this.getUser()
  },
  mounted() {
    this.updateTime() // 初始化时间
    this.timeInterval = setInterval(this.updateTime, 1000) // 每秒更新一次
  },
  beforeDestroy() {
    // 清除定时器
    clearInterval(this.timeInterval)
  },
  methods: {
    handleLook(e) {
      
      this.$router.push(e)
    },
    updateTime() {
      const now = new Date()
      const year = now.getFullYear()
      const month = (now.getMonth() + 1).toString().padStart(2, '0') // 月份从 0 开始，补充两位
      const day = now.getDate().toString().padStart(2, '0')
      const hours = now.getHours().toString().padStart(2, '0')
      const minutes = now.getMinutes().toString().padStart(2, '0')
      const seconds = now.getSeconds().toString().padStart(2, '0')

      // 格式化为 YYYY-MM-DD HH:mm:ss
      this.currentTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    // 获取用户信息
    getUser() {
      // getUserProfile().then((response) => {
      //   window.console.log('response 111', response)
      //   this.user = response.data
      //   this.roleGroup = response.roleGroup
      //   this.postGroup = response.postGroup
      // })
      console.log(1111)

      statHome().then((res) => {
        console.log(res, '的点点滴滴=========')
        this.statistics01 = res.data.statistics01
        const obj = {
          x: [],
          y: [],
        }
        obj.x = res.data.statisticalMonthlyData01.map((v) => v.mon)
        obj.y = res.data.statisticalMonthlyData01.map((v) => v.orderCount)
        this.chartData = obj
        const objs = this.statistics01
        this.chartData1 = {
          arr: [
            { value: objs.orderToBeSent, name: '待派单' },
            { value: objs.toBeModified, name: '已拒绝' },
            { value: objs.haveAccepted, name: '已受理' },
            { value: objs.toBeReviewed, name: '已提交' },
            { value: objs.completed, name: '已完成' },
            { value: objs.haveBeenCancelled, name: '已作废' },
          ],
        }
      })
      noticeWay({ pageNum: 1, pageSize: 4 }).then((res) => {
        console.log(res,'resresres')
        this.noticeList = res.data.records
        console.log(this.noticeList, 'noticeListnoticeList')
      })
    },
    onSponsorTabChange(key, type) {
      this[type] = key
    },
  },
}
</script>

<style lang="less" scoped>
@import './index.less';
.home {
  padding: 8px;
  padding-bottom: 0;
  height: 81.5vh;
  overflow-y: auto;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  .home_c{
    font-size: 100px;
  }
}
.ant-layout-content {
  margin: 0 !important;
}
</style>
